import { PlanDetails } from './types'

export const SYSTEM_SEND_STRIPE_ID = '14535'

export const planDetails: PlanDetails[] = [
  {
    plan: 'Basic',
    details: [
      { detail: '$2.75 per card' },
      {
        detail: 'Tiered pricing for System Sends',
        innerDetails: [
          { detail: '$2.75 per card' },
          { detail: '$2.50 per card for 25+' },
          { detail: '$2.25 per card for 50+' },
          { detail: '$2.00 per card for 100+' },
        ],
      },
      { detail: 'Full retail price on gifts' },
      { detail: 'Enhanced Storage' },
      { detail: 'Postage not included on any card sends' },
    ],
  },
  {
    plan: 'Card A Day',
    details: [
      {
        detail:
          '30 Monthly Card Sends (includes both Heartfelt and System Sends)',
      },
      {
        detail: '$1.75 per each additional card over 30 ',
      },
      { detail: '20 percent discount on gifts*' },
      { detail: 'Enhanced storage' },
      { detail: 'Postage not included on any card sends' },
    ],
  },
  {
    plan: 'Unlimited +30 System Sends',
    details: [
      {
        detail:
          'Unlimited Heartfelt Prompting Card Sends** (postage included!)',
      },
      { detail: '30 System Sends***' },
      {
        detail: '$1.50 per each additional System Send***',
      },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premium storage' },
      { detail: 'Postage not included on any System Sends' },
    ],
  },
  {
    plan: 'Unlimited +100 System Sends',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards** (postage included!)' },
      { detail: '100 System Sends*** (postage not included)' },
      {
        detail:
          '$1.25 per each additional System Send*** (postage not included)',
      },
      { detail: 'Expense account required on this plan' },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premium Storage' },
      { detail: 'Unlimited Campaign Store Downloads' },
    ],
  },
  {
    plan: 'Unlimited +250 System Sends',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards** (Postage included!)' },
      { detail: '250 System Sends*** (postage not included)' },
      {
        detail:
          '$1.00 per each additional System Send*** (postage not included)',
      },
      { detail: 'Expense account required on this plan' },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premium Storage' },
      { detail: 'Unlimited Campaign Store Downloads' },
    ],
  },
  {
    plan: 'Enterprise',
    details: [
      { detail: 'Unlimited Heartfelt Single Card Sends Including Stamps' },
      { detail: '$1.75/Group and Scheduled Cards' },
      { detail: '30% Discount on Gifts *' },
      { detail: 'Includes All Card Types' },
      { detail: '100 Free Cards Toward Group Sends Per Month' },
      { detail: 'Premium Storage' },
      { detail: 'Loyalty Rewards' },
      { detail: '+ Enhanced Plan Features' },
    ],
  },
]
